import { ModalModule } from '$core/modal/modal.module';
import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { ShellComponent } from './shell.component';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, ShellComponent],
  imports: [CommonModule, RouterModule, SharedModule, ModalModule],
  exports: [ShellComponent],
})
export class ShellModule {}
